var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60724 5.26776C9.40921 5.07237 10.8204 3.63947 10.9941 1.81579H10.8421C9.17039 1.81579 7.75921 2.90132 7.21645 4.37763C7.04276 4.00855 6.80395 3.66118 6.54342 3.35724C7.36842 1.81579 8.975 0.773683 10.8421 0.773683H11.3632C11.7322 0.773683 12.0579 1.09934 12.0579 1.46842C12.0579 3.94342 10.2125 5.98421 7.82434 6.28816C7.78092 5.94079 7.71579 5.61513 7.60724 5.26776ZM1.98421 3.20526V3.55263C1.98421 5.68026 3.67763 7.37368 5.80526 7.37368H5.97895V7.02632C5.97895 4.92039 4.26382 3.20526 2.15789 3.20526H1.98421ZM7.02105 7.02632V7.37368V8.41579V11.3684C7.02105 11.6724 6.78224 11.8895 6.5 11.8895C6.19605 11.8895 5.97895 11.6724 5.97895 11.3684V8.41579H5.80526C3.11316 8.41579 0.942105 6.24474 0.942105 3.55263V2.85789C0.942105 2.48882 1.24605 2.16316 1.63684 2.16316H2.15789C4.82829 2.16316 7.02105 4.35592 7.02105 7.02632Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/Leaf.a13aa2b4d871db730761b25457a7280d.svg";
export { ForwardRef as ReactComponent };